import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Workbox } from 'workbox-window';
function loadServiceWorker() {
  if ('serviceWorker' in navigator && environment.production) {
    const wb = new Workbox('/sw.js', {scope:'/'});
    wb.register();
  }
}
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then( _=> loadServiceWorker())
  .catch(err => console.error(err));
